// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OyUtC","newExpiryDate":"styles_newExpiryDate__1Px2g","footer":"styles_footer__v9QNT"};